import { T } from "@supersig/validate";
import { buildConditionalByReturnValueType } from "../../primitives";
import { swRecordIdValidator } from "../records/SWRecord";
const liquidText = T.object({
    type: T.literal("liquid"),
    liquid: T.string,
    requiredRecords: T.arrayOf(swRecordIdValidator)
});
const textLiteral = T.object({
    type: T.literal("literal"),
    text: T.string
});
const textConditional = buildConditionalByReturnValueType(T.union("type", {
    literal: textLiteral,
    liquid: liquidText
}));
export const textLeafProps = T.union("type", {
    liquid: liquidText,
    literal: textLiteral
});
export const textProps = T.union("type", {
    conditional: textConditional,
    liquid: liquidText,
    literal: textLiteral
}) // Change type liquid to by type "expression"
 // with liquid as a sub-type
;
